import { formatTimeAgo } from '@/utils'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(relativeTime)
dayjs.extend(utc)

export const formatTime = (time: string) => {
  const now = dayjs()
  const timestamp = dayjs.utc(time) // 解析 UTC 时间
  const diffInSeconds =
    now.diff(dayjs(timestamp), 'second') < 0 ? 0 : now.diff(dayjs(timestamp), 'second')
  return formatTimeAgo(diffInSeconds)
}
